export default __webpack_public_path__ + "static/media/iphone_10_info.33dec720.png";